<template lang="html">
  <div id="aster-plot-placeholder" />
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        pathColours: [
          '#A1E3EC',
          '#FFC085',
          '#0B162B',
          '#958058',
          '#EB2D7C',
          '#77D300',
          '#9FA0A2',
          '#FFF069',
          '#4A1E87',
          '#FF908D',
          '#4BB680',
          '#2C8E9C',
          '#FFD3AB',
          '#273248',
          '#412E0C',
          '#F581B2',
          '#89F003',
          '#C0B01E',
          '#9C79CD',
          '#FF6D69',
          '#158C4F',
          '#72CCD7',
          '#FF9E44',
          '#3F4B63',
          '#6C5935',
          '#C50053',
          '#C6F983',
          '#808284',
          '#FFF8B8',
          '#7952B1',
          '#C7221D',
          '#A7E7C7',
        ],
      };
    },
    props: {
      time_spent_key: {
        type: String,
        default() {
          return '';
        },
      },
    },
    computed: {
      ...mapGetters(['getClassSummaryLD']),
      data() {
        return this.getClassSummaryLD.student_participations.map((s) => s);
      },
    },
    mounted() {
      const clone = JSON.parse(JSON.stringify(this.data));
      let mostTimeInInnerCircle = '';
      if (this.time_spent_key === 'as-speaker') {
        mostTimeInInnerCircle = Math.round(
          Math.max(...clone.map((s) => s.turns_data.total_time_as_speaker), 0)
        );
      } else {
        mostTimeInInnerCircle = Math.round(
          Math.max(...clone.map((s) => s.turns_data.total_time_spoken), 0)
        );
      }

      const d3 = window.d3version4;
      const width = 500;
      const height = 500;
      const radius = 240;
      const innerRadius = 72;

      const pie = d3
        .pie()
        .sort(null)
        .value((d) => d.width);

      const arc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius((d) => {
          let calc;

          if (d.data.time === mostTimeInInnerCircle) {
            calc = radius;
          } else {
            calc =
              (radius - innerRadius) * (d.data.time / mostTimeInInnerCircle) +
              innerRadius;
          }

          // NOTE: Aug 2019 - I commented out the line below and returned just calc
          // because it was treating people who spoke 0 minutes just like people
          // who spoke the most. Leaving it here in case it was doing something
          // important that I just didn't understand at the time
          // return calc === 75 ? 250 : calc;

          return Math.max(85, calc);
        });

      const outlineArc = d3.arc().innerRadius(innerRadius).outerRadius(radius);

      const svg = d3
        .select('#aster-plot-placeholder')
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

      const fill = d3.scaleOrdinal().range(this.pathColours);

      let data = [];
      if (this.time_spent_key === 'as-speaker') {
        data = clone.map((d) => {
          return {
            color: d.turns_data.total_time_as_speaker
              ? fill(d.user_id)
              : '#ffffff',
            name: d.user_name,
            id: d.user_id,
            width: 1,
            time: Math.round(d.turns_data.total_time_as_speaker),
          };
        });
      } else {
        data = clone.map((d) => {
          return {
            color: d.turns_data.total_time_spoken ? fill(d.user_id) : '#ffffff',
            name: d.user_name,
            id: d.user_id,
            width: 1,
            time: Math.round(d.turns_data.total_time_spoken),
          };
        });
      }

      svg
        .selectAll('.solidArc')
        .data(pie(data))
        .enter()
        .append('path')
        .attr('fill', (d) => d.data.color)
        .attr('class', 'solidArc')
        .attr('stroke', 'gray')
        .attr('d', arc)
        .on('mouseover', function (d) {
          d3.selectAll('.solidArc').attr('fill', (d) =>
            d.data.color === '#ffffff' ? '#ffffff' : '#ececec'
          );
          d3.select(this).attr('fill', (d) => d.data.color);
          d3.select('#student-name-aster-plot').html(d.data.name);
          d3.select('#total-time-aster-plot').html(d.data.time);
          d3.select('.text-minutes-aster-plot').html(
            d.data.time === 1 ? 'minute' : 'minutes'
          );
        })
        .on('mouseout', () => {
          d3.selectAll('.solidArc').attr('fill', (d) => d.data.color);
          d3.select('#student-name-aster-plot').html('');
          d3.select('#total-time-aster-plot').html('');
          d3.select('.text-minutes-aster-plot').html('');
        });

      svg
        .selectAll('.outlineArc')
        .data(pie(data))
        .enter()
        .append('path')
        .attr('fill', 'none')
        .attr('stroke', 'gray')
        .attr('class', 'outlineArc')
        .attr('d', outlineArc);

      svg
        .append('svg:text')
        .attr('id', 'student-name-aster-plot')
        .attr('dy', '-1.5em')
        .attr('dx', '0em')
        .attr('text-anchor', 'middle');

      svg
        .append('svg:text')
        .attr('id', 'total-time-aster-plot')
        .attr('dy', '.35em')
        .attr('dx', '-.1em')
        .attr('text-anchor', 'middle');

      svg
        .append('svg:text')
        .attr('class', 'text-minutes-aster-plot')
        .attr('dy', '3.0em')
        .attr('dx', '-.4em')
        .attr('text-anchor', 'middle');
    },
  };
</script>

<style lang="stylus">
  @import '~app/global-stylus.styl'

  #student-name-aster-plot
    font-weight: bold
    font-size: 14px

  #total-time-aster-plot
    font-weight: bold
    font-size: 24px

  .text-minutes-aster-plot
    font-size: 12px

  .solidArc
    -moz-transition: all 0.3s
    -o-transition: all 0.3s
    -webkit-transition: all 0.3s
    transition: all 0.3s
</style>



// WEBPACK FOOTER //
// asterPlot.vue?4384f31c